import { Header } from "./misc"

export function ErrorPage() {
    return (
        <>
            <Header />
            <h1 className="text-center">Error 404: Page Not Found</h1>
        </>
    )
}

/**
 * Error boundary page as a fallback for my dumb errors
 * 
 * Should return this instead of a blank page for better user experience
 * 
 */
export function ErrorBoundaryPage() {
    return (
        <div>
            <Header />
            <h1 className="text-center">Error 500: Please refresh the page or contact administrator.</h1>
        </div>
    )
}

